import type { ProductOption, ProductVariant } from '@commerce/types/product'
import cn from 'clsx'
import { useTranslation } from 'next-i18next'
import { memo } from 'react'
import { SelectedOptions } from '../helpers'
import ProductOptionItem from './ProductOptionItem'
interface ProductOptionsProps {
  options: ProductOption[]
  variants: ProductVariant[]
  currencyCode?: string
  selectedOptions: SelectedOptions
  setSelectedOptions: React.Dispatch<React.SetStateAction<SelectedOptions>>
  colourConsultationProduct?: boolean
}

const ProductOptionsSelectedBox: React.FC<ProductOptionsProps> = ({
  options,
  variants,
  selectedOptions,
  setSelectedOptions,
  currencyCode,
  colourConsultationProduct,
}) => {
  const { t } = useTranslation('common')
  const getPriceForOptionLabel = (label: any) => {
    const productVariant = variants.filter(
      (v: ProductVariant) => v.name === label
    )
    const productPrice = productVariant?.[0]?.price
    return productPrice
  }
  return (
    <div>
      {options.map((opt) => {
        const defaultOption = colourConsultationProduct
          ? `${t('please-select')}`
          : `${t('please-select-size')}`
        const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
          const value = event.target.value
          if (value !== defaultOption) {
            setSelectedOptions({
              ...selectedOptions,
              [opt.displayName.toLowerCase()]: value,
            })
          } else {
            const newOptions = { ...selectedOptions }
            delete newOptions[opt.displayName]
            setSelectedOptions(newOptions)
          }
        }
        return (
          <div className="pb-4" key={opt.displayName}>
            <h2 className="label-bold capitalize">
              {opt.displayName.toLowerCase()}
            </h2>
            <div role="listbox" className="flex flex-row py-4">
              <select
                name={opt.displayName}
                onChange={selectChange}
                className={cn(
                  'lg:label w-full overflow-ellipsis rounded border border-ui-grey-25 bg-white py-3 px-4 text-brand-dark-grey',
                  {
                    label: !colourConsultationProduct,
                    'text-labelSmall': colourConsultationProduct,
                  }
                )}
              >
                <option>{defaultOption}</option>
                {opt.values.map((v, i: number) => {
                  return (
                    <ProductOptionItem
                      key={`${opt.id}-${i}`}
                      label={v.label}
                      value={v.label.toLowerCase()}
                      price={getPriceForOptionLabel(v.label)}
                      currencyCode={currencyCode!}
                    />
                  )
                })}
              </select>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default memo(ProductOptionsSelectedBox)
